<template>
    <section id="change-password" class="mt-auto">
        <div class="d-flex align-items-center">
            <button id="change-password-my-profile" class="d-block p1b text-center mx-auto" @click="showModal">
                <img :src="ICON_LOCK"
                     class="img-fluid" alt=""> 
                <span class="d-inline-block">Change Password</span>
            </button>
        </div>
    </section>
</template>

<script>
    import { ICON_LOCK } from "../../../constants";
    export default {
        name: "ChangePassword",
        data: () => ({
            ICON_LOCK
        }),
        methods: {
            showModal(){
                this.$store.commit('TOGGLE_MODAL', ['pass-pop', true]);
            }
        }
    }
</script>

<style scoped lang="scss">
#change-password {
    img {
        margin-right: 8px;
    }
    button {
        width: 210px;
        height: 43px;
        border: 1px solid #727CF5;
        border-radius: 5px;
        background: #fff;
        color: #727CF5;
        &:focus {
            border: 1px solid #727CF5 !important;
        }
    }
    span{
        margin-top: 2px;
        vertical-align: top;
    }
}

</style>